import styled from 'styled-components';
import { variables } from '../../../styles/variables';

export const ActionsElements = styled.span`
  display: flex;
  justify-content: flex-start;
  width: 100%;

  button {
    border: none;
    padding: 0;
    background-color: ${variables.colorWhite};
    margin: 0;
    display: inline;
    color: ${variables.colorMainText};
    span {
      font-size: 2.8rem;
      color: ${variables.colorMainText};
    }
    &:hover,
    &:focus-visible {
      background-color: ${variables.colorWhite};
      box-shadow: none;
      span {
        color: ${variables.colorDecorator};
      }
      &::after {
        content: none;
      }
    }
    &.ant-btn[disabled] {
      span {
        color: ${variables.colorDisabled};
      }
    }
    .smaller {
      transform: scale(0.85);
    }
  }
`;

export const ButtonWithText = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${variables.colorError};

  button {
    span {
      color: ${variables.colorError};
    }

    &:hover,
    &:focus-visible {
      background-color: ${variables.colorWhite};
      box-shadow: none;
      span {
        color: ${variables.colorError};
      }
      &::after {
        content: none;
      }
    }
  }

  .errorText {
    padding: 8px 24px 8px 0;
    cursor: pointer;
  }
`;
